$(document).ready(function () {
  function formatPrice(price) {
    return price.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  }

  const $flickity = $("product-gallery scroll-carousel").flickity({
    contain: false,
    draggable: true,
    wrapAround: true,
    prevNextButtons: false,
    pageDots: false,
    groupCells: true,
    cellAlign: "left",
  });
  
if ($(".product").length == 1) {
  
 $(".Product__SlideshowNavArrow--next").on("click", function(){ $flickity.flickity("next"); });
 $(".Product__SlideshowNavArrow--previous").on("click", function(){ $flickity.flickity("previous"); });
 
 function flickitySlider(){
    var value_input = $("input[name='option1']:checked").val();
    var value_input2 = $("input[name='option2']:checked").val();
    var value_input3 = $("input[name='option3']:checked").val();
     
      if(value_input3){
        var createCombo = value_input + " / " + value_input2 + " / " + value_input3;
      }else{
        var createCombo = value_input + " / " + value_input2;
      }
    $("span.custom_product_span").each(function () {
      var getTitle = $(this).text();
      if (getTitle == createCombo) {
        var dataIndex = $(this).attr("data-attr");
        var dataIndex1 = $(
          `.product-gallery__media[data-media-id="${dataIndex}"]`
        ).attr("index");
        $flickity.flickity("select", dataIndex1 - 1);
      } else {
        var value_input3 = $("input[name='option1']:checked").val();
        $("span.custom_product_span").each(function () {
          var getTitle = $(this).text();
          if (getTitle == value_input3) {
            var dataIndex = $(this).attr("data-attr");
            var dataIndex = $(this).attr("data-attr");
            var dataIndex1 = $(`.product-gallery__media[data-media-id="${dataIndex}"]`).attr("index");
            $flickity.flickity("select", dataIndex1 - 1);
          }
        });
      }
    });
  }
  flickitySlider();
  $(document).on("click",".variant-picker__option-values label",function(){
      setTimeout(function () {
          flickitySlider();
      }, 150);
    
    });
  }
  setTimeout(function() {
     $(".variant-picker__option-values-new input:first").attr("checked",true);
  },1000);
function customClass() {
  var variantId = window.location.href.split("variant=")[1];
  $.ajax({
    url: window.location.href,
    method: "GET",
    dataType: "json",
    success: function (response) {
      var variantsData = response.product.variants;
      variantsData.forEach((data) => {
        if (data.id == variantId) {
          var finalPrice = formatPrice(data.price);
          if (data.inventory_quantity <= 0) {
            $(".buy-buttons").addClass("soldOutProduct");
            $("safe-sticky buy-buttons .button.w-full").html(`<span class="sold-out-custom-cls">Sold out</span>`);
          } else {
            var activeCurrency = $("body").attr("store-currency");
            if (activeCurrency == "₹") {
              activeCurrency = "Rs.";
            }
            $(".buy-buttons").removeClass("soldOutProduct");
            $("safe-sticky buy-buttons .button.w-full").html(
              `<span>Add to cart</span><span>${activeCurrency} ${finalPrice}</span>`
            );
          }
        }
      });
    },
  });
}
$(document).on("click",".default-product-template .variant-picker__option-values label",function(){
  setTimeout(function () {
    var getText = $('buy-buttons.buy-buttons button[type="submit"]').text();
    if (getText.includes("Sold out")) {
      $(".default-product-template").addClass("the_product_is_sold_out");
    } else {
      $(".default-product-template").removeClass("the_product_is_sold_out");
    }
   //customClass();
  }, 100);
});
  
$(document).on("click",".bundle-product-template-pdp .variant-picker__option-values label",function () {
  setTimeout(function () {
    var getText = $('buy-buttons.buy-buttons button[type="submit"]').text();
    if (getText.includes("Sold out")) {
      $(".bundle-product-template-pdp").addClass("the_product_is_sold_out");
    } else {
      $(".bundle-product-template-pdp").removeClass("the_product_is_sold_out");
    }
    //customClass();
  }, 100);
});

$(document).on("click", ".product-gallery__zoom-button", (e) => {
  e.preventDefault();
  $(".product-gallery__media.snap-center.is-selected img").click();
});

$(document).on("click",'.buy-buttons[template="messenger-bag"]',(e) => {
      e.preventDefault();
      var variantId = $('.product .product-info .shopify-product-form input[name="id"]').val();
      var varColor = $(".variant-picker-new-custom .variant-picker__option-values-new input[type=radio]:checked").val();
      var bundleId = $(`.bundle-product[variant-name="${varColor}"]`).attr("variant-id");
      let formData = {items: [{id: variantId,quantity: 1,},{id: bundleId,quantity: 1,}]};

      fetch(window.Shopify.routes.root + "cart/add.js", {
        method: "POST",
        headers: {"Content-Type": "application/json",},
        body: JSON.stringify(formData),
      }).then((response) => {
          document.documentElement.dispatchEvent(new CustomEvent("cart:refresh", {bubbles: true,}));
          setTimeout(function () {
            $('.header__secondary-nav a[aria-controls="cart-drawer"]')[0].click();
          }, 100);
        }).catch((error) => {
          console.error("Error:", error);
        });
    });
  
  $(document).on("click",".variant-picker-new-custom .variant-picker__option-values-new .is-disabled",(e)=>{
      e.preventDefault();
      setTimeout(function () {
        $('.buy-buttons[template="messenger-bag"] button').text("sold out");
        $('.buy-buttons[template="messenger-bag"] button').addClass("sold-out-disabled");
      }, 100);
    });

  $(document).on("click",".bundle-product-template-pdp .variant-picker-new-custom .variant-picker__option-values-new  .available",function(){
      setTimeout(function () {
        $('.buy-buttons[template="messenger-bag"] button').removeClass("sold-out-disabled");
        //customClass();
      }, 100);
    }
  );

  $("body").on("click",".variant-picker-new-custom .variant-picker__option-values-new label",function () {
    $(this).prev().prop("checked", true);
    var colorName = $(this).prev().val();
    $(".variant-picker-new-custom").find("variant-option-value").text(colorName);
  });

  $(document).on("click",".bundle-product-template-pdp .variant-picker__option-values label",function () {
      setTimeout(function () {
        var checkSelected = $('.variant-picker-new-custom .variant-picker__option-values-new input[type="radio"]:checked').next().hasClass("is-disabled");
        if (checkSelected == false) {
          $('.buy-buttons[template="messenger-bag"] button').removeClass("sold-out-disabled");
          //customClass();
        } else {
          $(".buy-buttons").removeClass("soldOutProduct");
          $("safe-sticky buy-buttons .button.w-full").html(`<span class="sold-out-custom-cls">Sold out</span>`);
        }
      }, 100);
    }
  );
  function flickity_sliders($product) {
    var value_input = $product.find("input[name='option1']:checked").val();
    var value_input2 = $product.find("input[name='option2']:checked").val();
    var createCombo = value_input + " / " + value_input2;
    $product.find(".csmt-product-data span.custom_product_span").each(function () {
        var getTitle = $(this).text();
        if (getTitle == createCombo) {
          var dataIndex = $(this).attr("data-attr");
          var dataIndex1 = $(`.product-gallery__media[data-media-id="${dataIndex}"]`).attr("index");
          $flickity.each(function (n) {
            if (n == i) {
              $(this).flickity("select", dataIndex1 - 1);
            }
          });
        } else {
          var value_input = $product.find("input[name='option1']:checked").val();
          $product.find(".csmt-product-data span.custom_product_span").each(function () {
              var getTitle = $(this).text();
              if (getTitle == value_input) {
                var dataIndex = $(this).attr("data-attr");
                var dataIndex = $(this).attr("data-attr");
                var dataIndex1 = $( `.product-gallery__media[data-media-id="${dataIndex}"]`).attr("index");
                $flickity.each(function (n) {
                  if (n == i) {
                    $(this).flickity("select", dataIndex1 - 1);
                  }
                });
              }
            });
        }
      });
   }
  if ($(".product").length > 1) {
   
    $(".product").each(function (i) {
      var $product = $(this);
      setTimeout(function () {
       flickity_sliders($product);
      }, 100);
    });
    
    $(".product").each(function (i) {
      var $product = $(this);
      $product.on("click", ".variant-picker__option-values label", function () {
        setTimeout(function () {
          flickity_sliders($product);
        }, 100);
      });
    });

    $(".product").each(function(){
      var $flickityInstance = $(this).find(".product-gallery scroll-carousel").flickity();
      $(this).find(".Product__SlideshowNavArrow--next").on("click", function () { $flickityInstance.flickity("next"); });
      $(this).find(".Product__SlideshowNavArrow--previous").on("click", function () { $flickityInstance.flickity("previous"); });
    });

  }
/****************************
 * GLOBAL STATE
 ****************************/

let isRunning = false;
let rerunRequested = false;
let suppressCartEvents = false;

// Prevent duplicate add/remove requests for the same free gift
const pendingGiftAdds = new Set();
const pendingGiftRemovals = new Set();

/****************************
 * HELPERS
 ****************************/

/** Utility: Wait until element exists, then run callback */
function waitForElement(selector, callback) {
  const interval = setInterval(function () {
    if (document.querySelector(selector)) {
      clearInterval(interval);
      callback();
    }
  }, 100);
}

/** Promise wrapper so we can `await` it */
function waitForElementOnce(selector) {
  return new Promise((resolve) => {
    waitForElement(selector, resolve);
  });
}

/****************************
 * MAIN LOGIC
 ****************************/

async function handleFreeGifts(cart) {
  // Use the REAL cart subtotal from Shopify (in store currency)
  // items_subtotal_price is in cents
  const cartTotal = cart.total_price; // e.g. 150.00

  // Wait until the rewards bar exists (for tier elements / thresholds)
  await waitForElementOnce(".tiered-rewards-bar");

  $("#cart-drawer").addClass("loading");

  if($(".tiered-reward-tier.product-reward").length > 0){
    $(".tiered-reward-tier.product-reward").each(function () {
      const $tier = $(this);
      const productId = $tier.data("product-id");
      const thresholdTemp = parseFloat($tier.data("threshold")) || 0; // usually USD base

      const currency = $("body").attr("data-currency");

      // Convert threshold from USD to current currency
      const thresholdConverted = Currency.convert(
        thresholdTemp,
        "USD",
        currency
      );
      const threshold = Number(thresholdConverted.toFixed(2));

      let freeGiftItem = null;

      // Find this tier's free gift item in the cart
      cart.items.forEach(function (item) {
        if (
          item.id == productId &&
          item.properties &&
          item.properties["_freegift"]
        ) {
          freeGiftItem = item;
        }
      });

      /****************
       * ADD FREE GIFT
       ****************/
      if (!freeGiftItem && cartTotal >= threshold) {
        // Guard: don't send multiple add requests for same gift
        if (pendingGiftAdds.has(productId)) {
          $("#cart-drawer").removeClass("loading");
          return;
        }
        pendingGiftAdds.add(productId);

        const formData = {
          items: [
            {
              id: productId,
              quantity: 1,
              properties: { _freegift: true },
            },
          ],
        };

        suppressCartEvents = true;
        fetch(window.Shopify.routes.root + "cart/add.js", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(formData),
        })
          .then(() => {
            document.documentElement.dispatchEvent(
              new CustomEvent("cart:refresh", { bubbles: true })
            );
          })
          .catch((error) => console.error("Error adding free gift:", error))
          .finally(() => {
            suppressCartEvents = false;
            pendingGiftAdds.delete(productId);
            $("#cart-drawer").removeClass("loading");
          });

      /*******************
       * REMOVE FREE GIFT
       *******************/
      } else if (freeGiftItem && cartTotal < threshold) {
        // Guard: don't send multiple remove requests for same gift
        if (pendingGiftRemovals.has(productId)) {
          $("#cart-drawer").removeClass("loading");
          return;
        }
        pendingGiftRemovals.add(productId);

        suppressCartEvents = true;
        fetch(window.Shopify.routes.root + "cart/change.js", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
          },
          body: JSON.stringify({
            id: freeGiftItem.key,
            quantity: 0,
          }),
        })
          .then(() => {
            document.documentElement.dispatchEvent(
              new CustomEvent("cart:refresh", { bubbles: true })
            );
          })
          .catch((error) => console.error("Error removing free gift:", error))
          .finally(() => {
            suppressCartEvents = false;
            pendingGiftRemovals.delete(productId);
            $("#cart-drawer").removeClass("loading");
          });

      /************
       * NO CHANGE
       ************/
      } else {
        // Already correct for this tier
        $("#cart-drawer").removeClass("loading");
      }
    });
  }else{
    $("#cart-drawer").removeClass("loading");
  }
}


/****************************
 * ENTRY POINT / LOCK
 ****************************/

// Single entry point used by EVERYTHING
function requestHandleFreeGifts() {
  // If this event was caused by our own internal dispatch, ignore it.
  if (suppressCartEvents) {
    console.log("EVENT SUPPRESSED");
    return;
  }

  if (isRunning) {
    // We're already running → just remember that we need one more run
    rerunRequested = true;
    console.log("LOCKED (queued)");
    return;
  }

  // Kick off the worker
  runHandleFreeGifts();
}

async function runHandleFreeGifts() {
  isRunning = true;

  do {
    rerunRequested = false;

    console.log("LOCK ACQUIRED");
    try {
      const res = await fetch("/cart.js");
      const cart = await res.json();
      await handleFreeGifts(cart);
    } catch (e) {
      console.error(e);
    } finally {
      console.log("LOCK RELEASED");
    }

    // If any events fired while we were running, rerun once more
  } while (rerunRequested);

  isRunning = false;
}

/****************************
 * EVENTS
 ****************************/

// EVENTS → all go through the same entry point
document.addEventListener("cart:refresh", () => {
  console.log("cart:refresh");
  requestHandleFreeGifts();
});

document.addEventListener("cart:change", () => {
  console.log("cart:change");
  requestHandleFreeGifts();
});

// PAGE LOAD → also use the same entry point
requestHandleFreeGifts();


});


function formatMoney(cents, format = "") {
  if (typeof cents === "string") {
    cents = cents.replace(".", "");
  }
  const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/, formatString = format || window.themeVariables.settings.moneyFormat;
  function defaultTo(value2, defaultValue) {
    return value2 == null || value2 !== value2 ? defaultValue : value2;
  }
  function formatWithDelimiters(number, precision, thousands, decimal) {
    precision = defaultTo(precision, 2);
    thousands = defaultTo(thousands, ",");
    decimal = defaultTo(decimal, ".");
    if (isNaN(number) || number == null) {
      return 0;
    }
    number = (number / 100).toFixed(precision);
    let parts = number.split("."), dollarsAmount = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + thousands), centsAmount = parts[1] ? decimal + parts[1] : "";
    return dollarsAmount + centsAmount;
  }
  let value = "";
  switch (formatString.match(placeholderRegex)[1]) {
    case "amount":
      value = formatWithDelimiters(cents, 2);
      break;
    case "amount_no_decimals":
      value = formatWithDelimiters(cents, 0);
      break;
    case "amount_with_space_separator":
      value = formatWithDelimiters(cents, 2, " ", ".");
      break;
    case "amount_with_comma_separator":
      value = formatWithDelimiters(cents, 2, ".", ",");
      break;
    case "amount_with_apostrophe_separator":
      value = formatWithDelimiters(cents, 2, "'", ".");
      break;
    case "amount_no_decimals_with_comma_separator":
      value = formatWithDelimiters(cents, 0, ".", ",");
      break;
    case "amount_no_decimals_with_space_separator":
      value = formatWithDelimiters(cents, 0, " ");
      break;
    case "amount_no_decimals_with_apostrophe_separator":
      value = formatWithDelimiters(cents, 0, "'");
      break;
    default:
      value = formatWithDelimiters(cents, 2);
      break;
  }
  if (formatString.indexOf("with_comma_separator") !== -1) {
    return formatString.replace(placeholderRegex, value);
  } else {
    return formatString.replace(placeholderRegex, value);
  }
}


function extractAmount(text) {
 // Match a number that starts and ends with a digit (no trailing . or ,)
  const match = text.match(/(\d[\d.,]*\d|\d)/);
  if (!match) return null;

  let raw = match[1]; // e.g. "284,905.00", "185.00", "3,333,335", "12.345.678,99"

  // Find last separator inside the captured number
  const lastDot = raw.lastIndexOf('.');
  const lastComma = raw.lastIndexOf(',');
  const lastSep = Math.max(lastDot, lastComma);

  let integerPart = raw;

  // If last separator is followed by exactly 2 digits, treat as decimal and strip it
  if (lastSep !== -1) {
    const decimalPart = raw.slice(lastSep + 1);
    if (/^\d{2}$/.test(decimalPart)) {
      integerPart = raw.slice(0, lastSep); // drop decimals
    }
  }

  // Remove remaining thousand separators
  integerPart = integerPart.replace(/[.,]/g, "");

  return integerPart ? parseInt(integerPart, 10) : null;
}

function handleRewardsBar() {
  if ($('.tiered-rewards-bar').length == 0) return;
  
  $('.tiered-rewards-message').html('Calculating...');
  
  setTimeout(function () {
    const cart_total = parseFloat($('.tiered-rewards-bar').data('cart-total'));
    const currency = $('body').attr('data-currency');
    const hasFreeShippingBanner = $('#FreeShippingBanner').length > 0;
    
    let freeShippingAmount = 0;
    if (hasFreeShippingBanner) {
      const freeShippingText = $('#FreeShippingBanner').text();
      const match = extractAmount(freeShippingText);
      freeShippingAmount = match ? match * 100 : 0;
    }
    
    let next_threshold = null;
    let next_reward = null;
    let max_threshold = 0;
    const tiers = [];

    // First pass: collect threshold data and find next reward
    $(".tiered-reward-tier").each(function () {
      const $tier = $(this);
      const thresholdTemp = parseFloat($tier.data("threshold")) || 0;
      const isProductReward = $tier.hasClass('product-reward');
      
      let threshold;
      if (hasFreeShippingBanner && !isProductReward) {
        threshold = freeShippingAmount;
      } else {
        threshold = Math.ceil(Currency.convert(thresholdTemp, 'USD', currency));
      }

      tiers.push({ $element: $tier, threshold });

      if (cart_total < threshold && (next_threshold === null || threshold < next_threshold)) {
        next_threshold = threshold;
        next_reward = $tier.find(".reward-title").text();
      }

      if (threshold > max_threshold) {
        max_threshold = threshold;
      }
    });

    // Second pass: position tiers and set CSS variables
    if(!window.positionUpdate){
      tiers.forEach(({ $element, threshold }, index) => {
        const percent = Math.min((threshold / max_threshold) * 100, 100).toFixed(2);
        const leftPosition = `calc(${percent}% - 10px)`;
        // Store position as CSS variable on #cart-drawer
        $('body').css(`--reward-${index + 1}`, leftPosition);
        
        window.positionUpdate = true;
      });
    }

    // Update message
    if (next_threshold !== null) {
      const amount_needed = next_threshold - cart_total;
      $('.tiered-rewards-bar .tiered-rewards-message').html(
        `You're ${formatMoney(amount_needed, window.themeVariables.moneyFormat)} away from <strong>${next_reward}!</strong>`
      );
    } else {
      $('.tiered-rewards-bar .tiered-rewards-message').html(
        `Congrats! You've unlocked <strong>all available rewards</strong>! 🎉`
      );
    }

    // Update progress bar
    const progressPercent = Math.min((cart_total / max_threshold) * 100, 100).toFixed(2);
    $('body').css('--tiered-rewards-bar-percentage', `calc(${progressPercent}% - 20px)`);
  }, 500);
}


$(document).ready(function () {
  window.positionUpdate = false;
  if($('body').attr('data-currency') != 'USD'){
    //set interval to wait for #FreeShippingBanner
    const interval = setInterval(function() {
      if($('#FreeShippingBanner').length){
        clearInterval(interval);
        handleRewardsBar();
      }
    }, 500);
  }else{
    handleRewardsBar();
  }
});